import { render, staticRenderFns } from "./Atribute.vue?vue&type=template&id=468d7a90&"
import script from "./Atribute.vue?vue&type=script&lang=js&"
export * from "./Atribute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports